import { jsx } from "react/jsx-runtime";
import { styled, IconButton } from "@mui/material";
import { IconEye } from "./icons.js";
import { shouldNotForwardProps } from "../../../utils/shouldNotForwardProps.js";
import { iconSizeMap } from "../../common/Common.js";
const sizeStyles = {
  sm: {
    width: 42
  },
  md: {
    width: 42
  },
  lg: {
    width: 50
  }
}, PasswordEyeButton_ = styled(
  IconButton,
  shouldNotForwardProps(["inputSize"])
)(({ theme: t, inputSize }) => ({
  padding: 0,
  margin: 0,
  border: "none",
  background: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "absolute",
  top: 0,
  right: 0,
  height: "100%",
  "svg path": {
    fill: t.palette.grey[400]
  },
  svg: {
    width: iconSizeMap[inputSize],
    height: "auto"
  },
  ...sizeStyles[inputSize]
})), PasswordEyeButton = ({ size, eyeOpen, ...props }) => /* @__PURE__ */ jsx(
  PasswordEyeButton_,
  {
    type: "button",
    className: "pwd-icon",
    inputSize: size,
    ...props,
    children: /* @__PURE__ */ jsx(IconEye, { open: eyeOpen })
  }
);
export {
  PasswordEyeButton
};
//# sourceMappingURL=PasswordEyeButton.js.map
